import React from 'react'

export default function Footer() {
    return (
        <>
        

<div className="footer_container">


    <footer>
<p>

<a href="https://hegade-dev.herokuapp.com" style={{
    textDecoration:"underline",

    cursor:"pointer"

}}> Developed By S Hegade</a>   
<br/>

<strong>
    All rights Reserved &copy;
</strong>
</p>
    </footer>
</div>

        </>
    )
}
